var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isCapturable()
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("global.messages.warning.ordenRequerido")
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.isCapturable()
            ? _c(
                "b-container",
                _vm._l(
                  _vm.form.solicitud?.perfil?.principal?.contactosEmergencia,
                  function (contacto) {
                    return _c(
                      "b-row",
                      { key: contacto },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "lg",
                                  label: _vm.$t(
                                    "apeironGwApp.contactosEmergencia.label.nombres"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "nombre",
                                    disabled: "",
                                    size: "sm",
                                  },
                                  model: {
                                    value: contacto.nombre,
                                    callback: function ($$v) {
                                      _vm.$set(contacto, "nombre", $$v)
                                    },
                                    expression: "contacto.nombre",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "lg",
                                  label: _vm.$t(
                                    "apeironGwApp.contactosEmergencia.label.primerApellido"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "primerApellido",
                                    disabled: "",
                                    size: "sm",
                                  },
                                  model: {
                                    value: contacto.primerApellido,
                                    callback: function ($$v) {
                                      _vm.$set(contacto, "primerApellido", $$v)
                                    },
                                    expression: "contacto.primerApellido",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "lg",
                                  label: _vm.$t(
                                    "apeironGwApp.contactosEmergencia.label.segundoApellido"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "segundoApellido",
                                    disabled: "",
                                    size: "sm",
                                  },
                                  model: {
                                    value: contacto.segundoApellido,
                                    callback: function ($$v) {
                                      _vm.$set(contacto, "segundoApellido", $$v)
                                    },
                                    expression: "contacto.segundoApellido",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "lg",
                                  label: _vm.$t(
                                    "apeironGwApp.contactosEmergencia.label.correoElectronico"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "correo",
                                    disabled: "",
                                    size: "sm",
                                  },
                                  model: {
                                    value: contacto.correo,
                                    callback: function ($$v) {
                                      _vm.$set(contacto, "correo", $$v)
                                    },
                                    expression: "contacto.correo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  "label-size": "lg",
                                  label: _vm.$t(
                                    "apeironGwApp.contactosEmergencia.label.celular"
                                  ),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "celular",
                                    disabled: "",
                                    size: "sm",
                                  },
                                  model: {
                                    value: contacto.celular,
                                    callback: function ($$v) {
                                      _vm.$set(contacto, "celular", $$v)
                                    },
                                    expression: "contacto.celular",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCapturable()
            ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("apeironGwApp.contactosEmergencia.label.nota")
                    ),
                  },
                }),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }